import {createSelector} from 'reselect';

import {featureFlagsSelector} from '../../../../store/gsConfig/selectors';
import FEATURE_FLAGS from '../../../../utils/featureFlags';

const cartSelector = (state) => state.cart || {};

export const cartIdSelector = createSelector(cartSelector, (cart = {}) => cart.cartId);

export const listingSelectedSelector = createSelector(
  (state) => state.event,
  ({listingSelected}) => listingSelected
);

export const listingSelector = createSelector(
  (localState) => localState.listing,
  (listing) => listing || {}
);

export const paymentMethodsSelector = createSelector(
  ({event = {}}) => event.paymentMethods,
  (paymentMethods = {}) => paymentMethods.paymentMethodList
);

export const localeSelector = (state = {}) => state.lang || 'en-US';

export const exchangeRateSelector = createSelector(
  ({event = {}}) => event && event.exchangeRate,
  (exchangeRate) => exchangeRate && exchangeRate.amount
);
export const sectionStatsSelector = createSelector(
  (localState) => localState.listings,
  ({sectionStats}) => sectionStats || {}
);

export const inventoryMapSelector = createSelector(
  (state) => state.listings || {},
  ({data = []}) => {
    const listingsMap = {};
    for (let i = 0; i < data.length; i++) {
      const {seats = []} = data[i];
      const [firstSeat = {}] = seats;
      const {listingId} = firstSeat;
      listingsMap[listingId] = data[i];
    }

    return listingsMap;
  }
);

export const dataSelector = createSelector(
  (state) => state.event,
  (state) => state.gsConfig,
  (state) => state.device,
  (event = {}) => {
    const {
      venueConfig = {},
      eventStats,
      dynamicAttributes = [],
      showTicketRecoInd,
      loading,
      eventImages,
      firstPerformer,
      performers,
      eventDateLocal,
      buyerMessages,
      showDisclaimer,
      currencyCode,
    } = event;
    const {venueId, id: venueConfigId} = venueConfig;
    const verifiedListings =
      dynamicAttributes &&
      dynamicAttributes.length &&
      dynamicAttributes.filter((dynamicAttribute = {}) => dynamicAttribute.name === 'verifiedListings');
    const verifiedListingsValue = verifiedListings.length && verifiedListings[0].value;
    const getVerifiedListingValueObj = (verifiedListingsValue && JSON.parse(verifiedListingsValue)) || {};

    return {
      isGA: event.isGA,
      eventId: event.eventId,
      showTicketRecoInd,
      eventStats,
      venueId,
      venueConfigId,
      eventDateLocal,
      buyerMessages,
      performer: firstPerformer,
      performers,
      eventImages,
      venueConfig,
      logo: getVerifiedListingValueObj.logo,
      tagLine: getVerifiedListingValueObj.tagline,
      eventLoading: loading,
      showDisclaimer,
      currencyCode,
    };
  }
);

export const showRestrictionsSelector = createSelector(
  featureFlagsSelector,
  (features) => features && features[FEATURE_FLAGS.common.fanProtectRestrictions]
);

export const showFanProtectWarrantySelector = createSelector(
  featureFlagsSelector,
  (features) => features && features[FEATURE_FLAGS.byo.legal.fanProtectWarranty.show]
);
